import React, { Fragment } from 'react';
import { connect } from '../../redux/store';
import { PageTitle } from '../shared/PageTitle';
import { CoreForm, I18n } from '@kineticdata/react';
import {
  ErrorMessage,
  Image,
  C,
  H,
  ReportSiteIssueWrapper,
} from '@kineticdata/bundle-common';
import { MaintenanceWrapper } from './MaintenanceWrapper';
import classNames from 'classnames';

const Layout = connect(state => ({
  reportForm: H.selectReportSiteIssueForm(state),
}))(
  ({ form, submission, content, reportForm }) =>
    !submission ||
    submission.coreState === C.CORE_STATE_DRAFT ||
    submission.displayedPage?.type === 'confirmation' ? (
      <ReportSiteIssueWrapper form={form} reportForm={reportForm}>
        {content}
      </ReportSiteIssueWrapper>
    ) : (
      <ErrorMessage
        message={`You cannot edit a ${submission.coreState} submission`}
      />
    ),
);

export const Form = ({
  form,
  category,
  submissionId,
  handleCreated,
  handleUpdated,
  handleCompleted,
  handleLoaded,
  handleUnauthorized,
  values,
  kappSlug,
  formSlug,
  frameless,
  rootLabel,
  rootPath,
  favorite,
  handleToggleFavorite,
  authenticated,
}) => (
  <Fragment>
    <div className="page-container">
      {form &&
        form.image && (
          <div className="page-image">
            <Image src={form.image} alt="" />
          </div>
        )}
      <div className="page-panel">
        <PageTitle
          className="page-title-heading--sm"
          parts={[form ? form.name : '']}
          breadcrumbs={
            !frameless
              ? [
                  {
                    label: (
                      <span>
                        <span className="fa fa-fw fa-md fa-arrow-left text-muted" />
                        <I18n>{rootLabel}</I18n>
                      </span>
                    ),
                    to: rootPath,
                  },
                  category && {
                    label: category.name,
                    to: `${rootPath}/categories/${category.slug}`,
                  },
                ]
              : undefined
          }
          title={form ? form.name : ''}
          actions={[
            {
              icon: `heart fa-lg ${
                favorite ? 'text-primary' : 'far text-dark'
              }`,
              className: 'btn-icon btn-icon-toggle',
              onClick: handleToggleFavorite,
              aria: 'Toggle Favorite',
            },
          ]}
        />

        <div className={classNames('mb-5', { 'centered-form': frameless })}>
          <MaintenanceWrapper maintenance={form && form.maintenance}>
            {submissionId ? (
              <I18n submissionId={submissionId} public={!authenticated}>
                <CoreForm
                  submission={submissionId}
                  loaded={handleLoaded}
                  updated={handleUpdated}
                  completed={handleCompleted}
                  unauthorized={handleUnauthorized}
                  public={!authenticated}
                  layoutComponent={Layout}
                />
              </I18n>
            ) : (
              <I18n
                context={`kapps.${kappSlug}.forms.${formSlug}`}
                public={!authenticated}
              >
                <CoreForm
                  kapp={kappSlug}
                  form={formSlug}
                  loaded={handleLoaded}
                  created={handleCreated}
                  updated={handleUpdated}
                  completed={handleCompleted}
                  unauthorized={handleUnauthorized}
                  values={values}
                  public={!authenticated}
                  layoutComponent={Layout}
                />
              </I18n>
            )}
          </MaintenanceWrapper>
        </div>
      </div>
    </div>
  </Fragment>
);
